// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"453b71c7","368":"470a7aab","415":"70186384","794":"4ad61c71"}[chunkId] + ".chunk.js";
};